import $ from 'jquery'; 

const Navbar = props => {

  const toggleSideBar = () => {
    if ($('.nav_bar').css('display') === 'none') {
      // open
      $('.nav_bar').css('display', 'block');
      $('body').css('overflow', 'hidden');
      $('.app').css('background-color', 'rgba(192,192,192,0.3)');
    } else {
      // close
      $('.nav_bar').css('display', 'none');
      $('body').css('overflow', 'auto');
      $('.app').css('background-color', '#fff');
    }
  }

  const changeMenu = (event) =>{
    props.onChange(event.target.id)
    var w = window.innerWidth;
    if(w <= 600){
      toggleSideBar()
    }
  }
  
  return (
    <div className="nav_bar">
      <ul>
        <li id="back_to_shop" onClick={changeMenu}>Takaisin ostoksille</li>
        <li id="landing" className="selected" onClick={changeMenu}>Oma eKukka</li>
        <li id="history" onClick={changeMenu}>Omat tilaukset</li>
        <li id="userProfile" onClick={changeMenu}>Omat tiedot</li>
        <li id="log_out" onClick={changeMenu}>Kirjaudu ulos</li>
      </ul>
    </div>
  )
}

export default Navbar;
